import { useStationRisk } from '@/api/hooks/useDashboards';
import { StationRiskTable } from '@/components/dashboards/StationRiskTable';

/**
 * Station risk tile group — top-20 stations by within-brand fraud-rate
 * percentile over a fixed trailing 90-day window (no period selector;
 * matches the endpoint's contract). Backed by
 * `GET /api/v1/dashboards/station-risk`.
 */
export function StationRiskTiles(): JSX.Element {
  const { data, isLoading, error } = useStationRisk();

  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-sm font-semibold text-muted-foreground">
        Station Risk — Trailing 90 Days
      </h2>
      <StationRiskTable
        kpis={data?.kpis}
        isLoading={isLoading}
        error={(error as Error) ?? null}
        emptyMessage="No stations with transaction volume in the trailing 90 days."
      />
    </div>
  );
}
